import { render, staticRenderFns } from "./GlossaryPage.vue?vue&type=template&id=223880f2&scoped=true&"
import script from "./GlossaryPage.vue?vue&type=script&lang=js&"
export * from "./GlossaryPage.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryPage.vue?vue&type=style&index=0&id=223880f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223880f2",
  null
  
)

export default component.exports